import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Card, Text } from '@mlc/web-ui-toolkit';
import _ from 'lodash';
import React from 'react';
import { useRouterLocation } from '../../../hooks/AppStateHook';
import { BreadcrumbElements } from './BreadcrumbElements';
import * as Styled from './styled';

interface Props {
	pageTitle: string;
	breadcrumbs: Breadcrumb[];
}

export type Breadcrumb = {
	relativePath: string;
	absolutePath?: string;
	title: string;
};

const Breadcrumbs: React.FunctionComponent<Props> = ({
	breadcrumbs,
	pageTitle,
}) => {
	const location = useRouterLocation();
	if (location.previousPath === '/search') {
		if (!_.find(breadcrumbs, crumb => crumb.relativePath === '/search')) {
			breadcrumbs.push({
				relativePath: '/search',
				title: 'Client search results',
			});
		}
	} else {
		_.remove(breadcrumbs, crumb => crumb.relativePath === '/search');
	}

	return (
		<Styled.Nav role="navigation" aria-label="breadcrumb">
			<Card marginBottom={6} marginTop={3}>
				<Styled.Ol>
					{_.map(breadcrumbs, (breadcrumb: Breadcrumb) => {
						const Link = breadcrumb.relativePath
							? Styled.RouterLink
							: Styled.AnchorLink;
						const path =
							breadcrumb.relativePath || (breadcrumb.absolutePath as string);
						return (
							<Styled.Li
								key={_.kebabCase(breadcrumb.title)}
								className="breadcrumb"
							>
								{/*
						// @ts-ignore */}
								<Link
									data-analytics-id={`breadcrumb-${_.kebabCase(
										breadcrumb.title
									)}`}
									{...{ [breadcrumb.relativePath ? 'to' : 'href']: path }}
								>
									{breadcrumb.title}
								</Link>
								<Styled.Chevron icon={faChevronRight} size="sm" />
							</Styled.Li>
						);
					})}
					<Styled.Li key={breadcrumbs.length}>
						<Text
							fontWeight="semibold"
							color="mlcWhite"
							aria-current="page"
							data-id={BreadcrumbElements.currentPageBreadcrumb}
						>
							{pageTitle}
						</Text>
					</Styled.Li>
				</Styled.Ol>
			</Card>
		</Styled.Nav>
	);
};

export default Breadcrumbs;
